import { CssBaseline, ThemeProvider } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { TokenProvider } from "./contexts/TokenContext";
import theme from "./theme";
import "./configs/amplifyConfig";
import { initSentry } from "./sentry";

// Initialize Sentry
initSentry();

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_API_KEY);
const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <TokenProvider>
        <QueryClientProvider client={queryClient}>
          {import.meta.env.MODE === "development" && <ReactQueryDevtools initialIsOpen={false} />}
          <Elements stripe={stripePromise}>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <App />
            </ThemeProvider>
          </Elements>
        </QueryClientProvider>
      </TokenProvider>
    </BrowserRouter>
  </StrictMode>,
);
